import { Injectable } from '@angular/core';
import { NotifyOptions, NotifyService } from '@farris/ui-notify';
import { MessagerService } from '@farris/ui-messager';
import { HttpRequestFaildInfo, ServerExceptionEntity } from '../types';
import { BsModalRef } from '@farris/ui-modal';
import { LogUtil } from '../utils/log.util';

export class NotifyType {
  static INFO = 'info';
  static SUCCESS = 'success';
  static ERROR = 'error';
  static WARNING = 'warning';
}

@Injectable({
  providedIn: 'root'
})
export class MessageNotifyService {

  constructor(
    private notifyService: NotifyService,
    private messagerService: MessagerService,
  ) { }

  /**
   * å¼¹åºéç¥æç¤ºæ¡
   * @param message æç¤ºä¿¡æ¯
   * @param notifyType æç¤ºç±»å
   */
  public notify(message: string, notifyType: string) {
    const option: NotifyOptions = {
      type: notifyType,
      msg: message,
      timeout: 3500,
      showClose: true
    };
    this.notifyService[option.type](option);
  }

  /**
   * å¼¹åºéè¯¯ä¿¡æ¯æç¤ºæ¡
   */
  public showRequestErrorMessage(requestError: HttpRequestFaildInfo, safeHtml = false): void {
    const exceptionMsg = this.getErrorMessage(requestError);
    let bsModalRef: BsModalRef;
    const options = {
      showMaxButton: false,
      buttons: [
        {
          text: 'ç¡®å®',
          cls: 'btn btn-primary btn-lg',
          handle: () => {
            bsModalRef.close();
          }
        }
      ],
      width: 440,
      height: 200,
      safeHtml: safeHtml
    };
    const messageType = this.getMessageType(requestError);
    bsModalRef = this.messagerService.show(messageType, exceptionMsg, options);
  }

  public getErrorMessage(requestError: HttpRequestFaildInfo): string {
    const serverExceptionEntity = this.getServerExceptionEntity(requestError);
    return (serverExceptionEntity && serverExceptionEntity.Message)
      || (requestError && requestError.message) || 'Request Failed!';
  }

  /** å°è¯·æ±å¼å¸¸ä¿¡æ¯ä½æ ¼å¼åä¸ºobject */
  private getServerExceptionEntity(requestFailedInfo: HttpRequestFaildInfo): ServerExceptionEntity {
    const serverExceptionEntity = requestFailedInfo && requestFailedInfo.error;
    if (serverExceptionEntity) {
      switch (typeof serverExceptionEntity) {
        case 'string':
          return JSON.parse(serverExceptionEntity);
        case 'object':
          return serverExceptionEntity;
        default:
          LogUtil.error('ä¸æ¯æçè¯·æ±å¼å¸¸æ°æ®æ ¼å¼ï¼' + typeof serverExceptionEntity);
          LogUtil.error(serverExceptionEntity);
          return null;
      }
    } else {
      return null;
    }
  }


  /**
   * è·åä¿¡æ¯æç¤ºç±»å
   */
  private getMessageType(requestError: HttpRequestFaildInfo): string {
    const serverExceptionEntity = this.getServerExceptionEntity(requestError);
    let level = serverExceptionEntity && serverExceptionEntity.Level;
    if (level === null || level === undefined) {
      level = 2;
    }
    switch (level) {
      case 0:
        return NotifyType.INFO;
      case 1:
        return NotifyType.WARNING;
      case 2:
        return NotifyType.ERROR;
      case 3:
        return NotifyType.ERROR;
      default:
        return NotifyType.ERROR;
    }
  }

}
